import React from "react";
export const Guillemet = ({ color, size, info }) => (
	<svg width={size} className={info} viewBox="0 0 100 71.7">
		<polygon fill={color} points="27.3,28.7 46.1,2.7 20.2,2.6 1,29.1 1,69.2 46.1,69.2 46.1,35.7 27.3,28.7 	" />
		<polygon fill={color} points="80.3,28.7 99.1,2.7 73.2,2.6 54,29.1 54,69.2 99.1,69.2 99.1,35.7 80.3,28.7 	" />
	</svg>
)